export const PortalModule_VistaOffice = 130;
export const PortalModule_EditExpenseReceipt = 136;
export const PortalModule_OnboardDrivingInfo = 602;
